// extracted by mini-css-extract-plugin
export default {"container":"Breadcrumbs_container__vetp5","fa-beat":"Breadcrumbs_fa-beat__1xR4J"};